import ListKeyFiguresDevelopmentBox from './ListKeyFiguresDevelopmentBox'

export default ListKeyFiguresDevelopmentBox
